import React from 'react';
import { FaSnowplow, FaSnowflake, FaClock, FaMountain } from 'react-icons/fa';
import ContactForm from '../components/ContactForm'; // justera sökvägen om den ligger annorlunda
import { FaCheckCircle } from "react-icons/fa";
import { Helmet } from 'react-helmet';  // Importera Helmet

const Snorojning = () => {
  return (
    <>
    <Helmet>
            <title>Vinterunderhåll & Snöskottning – Provalt Service AB</title>
            <meta name="description" content="Trygg och pålitlig vinterunderhåll för privata och kommersiella fastigheter. Vi sköter snöskottning och halkbekämpning så du slipper oroa dig." />
            <link rel="canonical" href="https://provalt.se/vinterunderhall" />
          </Helmet>
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/images/gardening/provalt-snöplog.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />
        <div className="relative z-10 text-center p-6 bg-black bg-opacity-30">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Snöröjning</h1>
          <p className="text-xl md:text-2xl font-semibold">
            Trygg och snabb snöröjning – vi håller era ytor säkra
          </p>
        </div>
      </section>

      <section className="py-16 px-6 md:px-12 bg-white text-gray-800">
        <div className="max-w-6xl mx-auto space-y-8">
          <h2 className="text-3xl font-bold">Vinterunderhåll för tryggare utemiljöer</h2>
          <p className="text-lg">
            När snön faller behöver det finnas en plan – och vi har den redo. Provalt Service AB erbjuder pålitlig snöröjning, takskottning och halkbekämpning till fastighetsägare, bostadsrättsföreningar, företag och offentlig sektor. Med snabba insatser, dygnet runt vid behov, håller vi gångvägar, parkeringar och entréer fria från snö och is.
          </p>

          <div className="flex items-start">
            <FaSnowplow className="text-blue-500 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Maskinell & manuell snöröjning</h3>
              <p>Vi använder moderna plogbilar och handverktyg för att anpassa arbetet efter ytan – oavsett om det är stora parkeringar, små gångbanor eller trappor.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaSnowflake className="text-cyan-600 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Halkbekämpning</h3>
              <p>Med sandning, saltning eller miljövänliga alternativ ser vi till att ytorna förblir halkfria – även vid snabbt växlande temperaturer.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaMountain className="text-gray-600 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Takskottning & istappsavlägsning</h3>
              <p>Vi hanterar takskottning och tar bort istappar för att undvika olyckor och vattenskador, särskilt kring entréer och gångvägar.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaClock className="text-indigo-700 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Jour & beredskap</h3>
              <p>Vi erbjuder dygnet-runt-beredskap under vintermånaderna och är snabbt på plats vid akut snöfall eller halka.</p>
            </div>
          </div>

          <h3 className="text-2xl font-semibold pt-10">Anpassade lösningar</h3>
          <p className="text-lg">
            Alla fastigheter är olika – vi anpassar snöröjningen efter era behov och ytor. Våra abonnemang inkluderar ofta både förebyggande insatser och löpande kontroller under säsongen.
          </p>

          <p className="text-lg">
            Vi arbetar med moderna, bränslesnåla maskiner och miljöanpassade halkbekämpningsmedel. Med oss får du ett vinterunderhåll som är både effektivt och hållbart.
          </p>

        </div>
      </section>
      <section
      className="relative py-20 px-6 md:px-12 text-gray-900">
      {/* Vit overlay med transparens */}
      <div className="absolute inset-0 bg-white/90 backdrop-blur-sm"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
        {/* Textinnehåll */}
        <div className="space-y-8">
          <h2 className="text-3xl font-extrabold leading-tight">
            Vinterunderhåll för trygghet och säkerhet
          </h2>
          <ul className="space-y-6 text-lg">
            <li className="flex items-start">
              <FaCheckCircle className="text-blue-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Snöröjning & halkbekämpning:</strong> Vi håller era gångvägar och entréer säkra under vintern.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-blue-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Snabb respons vid snöfall:</strong> Våra team rycker ut snabbt för att undvika olyckor och störningar.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-blue-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Flexibla avtal:</strong> Anpassade lösningar för både privatpersoner och företag under hela vintersäsongen.
              </p>
            </li>
          </ul>
        </div>

        {/* Formulär */}
        <div className="bg-white p-2 rounded-3xl shadow-xl max-w-md w-full mx-auto">
          <ContactForm service="Vinterunderhåll" />
        </div>
      </div>
    </section>
    </>
  );
};

export default Snorojning;
